<template>
  <div class="yy">
    <!-- 上盒子 -->
    <div class="yy-box1">
        <!-- <div class="yy-box1-1">走进翼博</div> -->
        <ul>
            <li><router-link to="/honor/myzs1">企业简介</router-link></li>
            <li><router-link to="/honor/myzs2">企业文化</router-link></li>
            <li><router-link to="/honor/myzs3">组织架构</router-link></li>
            <li><router-link to="/honor/myzs4">企业资质</router-link></li>
            <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
            <li><router-link to="/honor/myzs6">新闻动态</router-link></li>
        </ul>
    </div>

    <!-- 下盒子 -->
    <div class="qyzz">
        <img src="@/assets/ryzs/ybcy.jpg" alt="">
        <img src="@/assets/ryzs/change01.png" alt="">
        <img src="@/assets/ryzs/change02.png" alt="">
        <img src="@/assets/ryzs/3.jpg" alt="">
        <img src="@/assets/ryzs/4.jpg" alt="">
        <img src="@/assets/ryzs/食品经营许可证.png" alt="">
        <img src="@/assets/ryzs/6.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/质量管理.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/食品安全.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/职业健康.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/环境管理.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/危害分析.jpg" alt="">
        <img class="sizeSty" src="@/assets/ryzs/01.png" alt="">
    </div>
  </div>
</template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style scoped>
  *{
    box-sizing: border-box;
}
  .qyzz  {
    width: 60%;
    margin: 0 auto;
  }
  .sizeSty {
    width: 40%;
  }
  </style>